module.exports = __webpack_public_path__ + "img/mia-central-south-terminal.db5b24e8.png";